import React, { Suspense } from "react";
import { BrowserRouter, useLocation, useNavigate } from "react-router-dom";
import { Spin } from "antd";
import AppRoutes from "./routes";
import NavigationTabs from "./components/NavigationTabs";

function AppLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    let aCount = 0;
    let bCount = 0;
    const onKeyDown = (event) => {
      const key = event.key.toLowerCase();
      if (key === "a") {
        if (bCount > 0) {
          aCount = 1;
          bCount = 0;
          return;
        }
        aCount = Math.min(aCount + 1, 3);
        return;
      }
      if (key === "b" && aCount === 3) {
        bCount += 1;
      } else {
        aCount = 0;
        bCount = 0;
      }
      if (aCount === 3 && bCount === 3) {
        aCount = 0;
        bCount = 0;
        navigate("/admin");
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [navigate]);

  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="app-title-wrap">
          <img className="app-title-logo" src="/logo-title.png" alt="" />
          <div className="app-title-text">
            <h1>Fuel Surcharge Calculator</h1>
            <h2>国内航线燃油附加费计算器</h2>
          </div>
        </div>
      </header>
      {!isAdmin && <NavigationTabs />}
      <main className="app-content">
        <Suspense fallback={<div className="loading-wrap"><Spin size="large" /></div>}>
          <AppRoutes />
        </Suspense>
      </main>
      <footer className="app-footer">
        <div className="footer-inner">
          <div className="footer-logo-row">
            <div className="footer-logo-slot footer-logo-slot--zaitu">
              <img className="footer-logo-zaitu" src="/logo-zaitu.svg" alt="" />
            </div>
            <div className="footer-logo-slot footer-logo-slot--lefu">
              <img className="footer-logo-lefu" src="/logo-lefu.svg" alt="乐福集采" />
            </div>
          </div>
          <p className="footer-tagline">行在途 · 享乐福</p>
        </div>
      </footer>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}
